var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapgal"},[_c('h3',[_vm._v("Galería del evento")]),_c('Carousel',{attrs:{"pics":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }